import PropTypes from "prop-types";

import { root, textContainer } from "./ContentTeaser.style";

const propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
};

const ContentTeaser = ({ children, isActive = false }) => {
  if (!children) return null;

  if (!isActive) return children;

  return (
    <div css={root} data-testid="content-teaser">
      <div css={textContainer}>{children}</div>
    </div>
  );
};

ContentTeaser.propTypes = propTypes;

export default ContentTeaser;
